import type { User } from "Interfaces";

export const isElevatedUser = (user: User) => {
	return user.role !== "user";
};
